export interface PlusIconProps {
  color?: 'blue' | 'black' | 'white';
  size?: 24 | 28 | 20; // 지원할 사이즈 명시
  className?: string;
}

const PlusIcon = ({ color = 'black', size = 28, className = '' }: PlusIconProps) => {
  const colorMap = {
    blue: '#004EFF',
    black: '#101010',
    white: '#FFFFFF',
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28" // viewBox는 유지하여 비율 보존
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M22 14L6 14" stroke={colorMap[color]} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14 6L14 22" stroke={colorMap[color]} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default PlusIcon;
